import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNHealthAgent } from 'src/app/models/cnhealthagent';
import { CNReport } from 'src/app/models/cnreport';
import { SNItem } from 'src/app/models/snitem';
import { ReportService } from 'src/app/services/report.service';

@ManageType('AdminReportValidationDialogComponent')
@Component({
  selector: 'app-admin-report-validation-dialog',
  templateUrl: './admin-report-validation-dialog.component.html',
  styleUrls: ['./admin-report-validation-dialog.component.scss']
})
export class AdminReportValidationDialogComponent implements OnInit {

  public reports: CNReport[] = [];
  public isValidated = false;
  public selectAll = true;

  private selectedUser: CNHealthAgent;
  private selectedReportIds: number[] = [];

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AdminReportValidationDialogComponent>,
              private report: ReportService) { }

  ngOnInit(): void {
  }

  loadReports(): void {
    const callSub = this.report.userReport(this.selectedUser, this.isValidated).subscribe(reports => {
      this.reports = reports;
      callSub.unsubscribe();
    });
  }

  selectUser(user: CNHealthAgent) {
    this.selectedUser = user;
    this.loadReports();
  }

  toggleChanged(event: MatSlideToggleChange) {
    this.isValidated = event.checked;
    this.loadReports();
  }

  select(flag: boolean) {
    this.selectAll = flag;
  }

  selectedReport(reports: number[]): void {
    this.selectedReportIds = reports;
  }

  sendEmail(): void {
    const reports: CNReport[] = [];
    this.report.emailReports(this.selectedUser, reports);
  }
}
